import React, {ReactElement, createElement} from 'react';
import {graphql, useStaticQuery} from 'gatsby';

export type SEOTags = {
  tagName?: string;
  content?: string;
  attributes?: {
    property?: string;
    content?: string;
    name?: string;
  };
}[];

export type FaviconTags = {
  tagName?: string;
  attributes?: {[key: string]: string};
}[];

export function SEO({
  tags,
  children,
}: {
  tags?: SEOTags;
  children?: ReactElement;
}) {
  const data = useStaticQuery<Queries.SEOStaticQuery>(graphql`
    query SEOStatic {
      datoCmsSite {
        faviconMetaTags {
          ...GatsbyDatoCmsFaviconMetaTags
        }
      }
    }
  `);
  const faviconTags = data?.datoCmsSite?.faviconMetaTags
    ?.tags as unknown as FaviconTags;

  return (
    <>
      {faviconTags.map(({tagName, attributes = {}}, index) => {
        if (tagName) {
          return createElement(tagName, {...attributes, key: index});
        }
        return null;
      })}
      {tags?.map(({tagName, content, attributes}, index) => {
        if (tagName === 'title' && content) {
          return <title key={index}>{content}</title>;
        } else if (tagName) {
          return createElement(tagName, {...attributes, key: index});
        }
        return null;
      })}
      {children}
    </>
  );
}
